import { render, staticRenderFns } from "./PaymentsFintoc.vue?vue&type=template&id=50be6768&scoped=true&"
import script from "./PaymentsFintoc.vue?vue&type=script&lang=js&"
export * from "./PaymentsFintoc.vue?vue&type=script&lang=js&"
import style0 from "./PaymentsFintoc.vue?vue&type=style&index=0&id=50be6768&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50be6768",
  null
  
)

export default component.exports